'use client';

import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from '../product-diagram-drawer/product-diagram-drawer-header/product-diagram-drawer-header.module.scss';
import { CatHeading } from 'components/blocks-components';

interface DrawerBackHeaderProps {
  className?: string;
  handleClose: () => void;
  drawerHeading: string;
  drawerSubHeading?: string;
  cartServerBtn?: React.ReactNode;
}

export const ProductDiagramDrawerBackHeaderMobile: FC<
  PropsWithChildren<DrawerBackHeaderProps>
> = ({
  className,
  handleClose,
  drawerHeading,
  drawerSubHeading = '',
  cartServerBtn,
  children
}) => {
  return (
    <div slot="header" className={cx(className, 'cat-u-display-flex', 'gap-2')}>
      <div className={styles['product-diagram-drawer-header-top-row']}>
        <CatButton
          variant="ghost"
          data-testid="cat-back-button"
          hideText={true}
          onClick={handleClose}
        >
          <CatIconArrowBack
            slot="before"
            className={styles['drawer-back-header-arrow']}
          />
        </CatButton>

        <div className={styles['product-diagram-drawer-header-titles']}>
          <CatHeading variant="title-sm">{drawerHeading}</CatHeading>
          <CatHeading variant="body-sm">
            <span className={cx('text-capitalize', styles['cart-sub-heading'])}>
              {drawerSubHeading}
            </span>
          </CatHeading>
        </div>
        {cartServerBtn}
      </div>

      {children}
    </div>
  );
};
